// extracted by mini-css-extract-plugin
export default {"headerSection":"Header_headerSection__7wuNu"};